import { Info } from 'lucide-react';

import { Button } from '@/components/shadcn/ui/button';
import { errorHandler } from '@/error-handler';
import { withForm } from '@/shared/ui/form';
import { toast } from '@/stores/pure/ToastStore';
import { WORKFLOW_TYPE } from '@/types/workflowConst';

import { previewNotification } from '../../api';
import { signalAlertFormOptions } from '../../model';
import { NotificationChannelForm } from '../notification-channel';
import { mapFormDataToSignal } from './signal-alert-utils';

export const SignalAlertActionSection = withForm({
  ...signalAlertFormOptions,
  props: {
    workspaceId: '',
  },
  render: function SignalAlertActionSection({ form, workspaceId }) {
    // Test connection 핸들러
    const handleTestConnection = async () => {
      try {
        await previewNotification({
          workspace_id: workspaceId,
          title: 'Signal Alert Test',
          enable: true,
          type: WORKFLOW_TYPE.SIGNAL_ALERT,
          signal: mapFormDataToSignal(form.state.values),
          channel: form.state.values.channel,
        });
        toast('Test notification sent', 'success');
      } catch (error) {
        toast(errorHandler(error, 'Failed to test alert'), 'fail');
      }
    };

    return (
      <div className="flex flex-col gap-5 rounded-lg border p-5">
        {/* 헤더 */}
        <div className="flex items-center gap-2">
          <Info className="size-5 text-red-500" />
          <span className="text-sm font-semibold">Action</span>
        </div>

        {/* Integrate 영역 */}
        <div className="grid grid-cols-[100px_1fr] items-start gap-3">
          <span className="pt-2 text-sm text-muted-foreground">Integrate</span>
          <NotificationChannelForm
            form={form}
            workspaceId={workspaceId}
            renderTestConnection={(canSubmit) => (
              <Button
                variant="outline"
                size="sm"
                className="w-fit"
                onClick={handleTestConnection}
                disabled={!canSubmit}
              >
                Test connection
              </Button>
            )}
          />
        </div>
      </div>
    );
  },
});
